import styled from "styled-components";
import { Image } from "react-bootstrap";
import { Modal } from "react-rainbow-components";

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  font-family: "Prompt";
`;

export const HeaderText = styled.p`
  font-size: 32px;
  color: #123559;
  font-weight: bold;
`;

export const ProfileContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageProfile = styled(Image)`
  margin-right: 1.5rem;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
`;

export const DescriptionContainer = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const ProfileName = styled.p`
  font-size: 24px;
  color: #123559;
  font-weight: 600;
  margin: 0;
`;

export const CaseIdText = styled.p`
  font-size: 16px;
  color: rgb(18, 53, 89, 0.7);
  font-weight: 400;
  margin: 0;
`;

export const PetNameContainer = styled.p`
  font-size: 16px;
  line-height: 2em;
  color: #c4c4c4;
  font-weight: 400;
  margin: 0;
`;

export const PetSpan = styled.span`
  font-size: 16px;
  color: #123559;
  font-weight: 400;
  margin: 0;
`;

export const ButtonContainer = styled.section`
  display: flex;
  justify-content: space-around;
  margin-top: 0.5rem;
  width: calc(100% - 7rem);
  position: relative;
`;

export const ConfirmButton = styled.button`
  background-color: #0dd07e;
  color: #fff;
  border-radius: 20px;
  margin: 1rem 0rem;
  padding: 0.5rem;
  border: 3px solid #0dd07e;
  width: 10rem;
`;

export const CancelButton = styled.button`
  background-color: #fff;
  border-radius: 20px;
  margin: 1rem 0rem;
  padding: 0.5rem;
  border: 3px solid #0dd07e;
  width: 10rem;
`;

export const ModalImplement = styled(Modal)`
  border-radius: 32px;
`;
